const STRIDE = 1

const getRandPixel = () => {
  return Math.round(Math.random()) * 2 - 1
}

export const wild = (position) => {
  const nextPosition = {
    ...position,
    x: position.x + getRandPixel(),
    y: position.y + getRandPixel()
  }
  return nextPosition
}

export const moveLeft = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    x: position.x - stride,
    direction: ['left']
  }
  return nextPosition
}

export const moveRight = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    x: position.x + stride,
    direction: ['right']
  }
  return nextPosition
}
export const moveUp = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    y: position.y - stride,
    direction: ['up']
  }
  return nextPosition
}
export const moveDown = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    y: position.y + stride,
    direction: ['down']
  }
  return nextPosition
}
export const moveUpRight = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    x: position.x + stride,
    y: position.y - stride,
    direction: ['up', 'right']
  }
  return nextPosition
}
export const moveDownRight = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    x: position.x + stride,
    y: position.y + stride,
    direction: ['down', 'right']
  }
  return nextPosition
}
export const moveUpLeft = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    x: position.x - stride,
    y: position.y - stride,
    direction: ['up', 'left']
  }
  return nextPosition
}
export const moveDownLeft = (position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    x: position.x - stride,
    y: position.y + stride,
    direction: ['down', 'left']
  }
  return nextPosition
}

export const pause = (position) => {
  return position
}

export const moveToTarget = (x, y, position, stride = STRIDE) => {
  const nextPosition = {
    ...position,
    direction: []
  }

  if (position.x < x) {
    let move = position.x + stride
    if (move > x) move = x
    nextPosition.x = move
    nextPosition.direction.push('right')
  } else if (position.x > x) {
    let move = position.x - stride
    if (move < x) move = x
    nextPosition.x = move
    nextPosition.direction.push('left')
  }

  if (position.y < y) {
    let move = position.y + stride
    if (move > y) move = y
    nextPosition.y = move
    nextPosition.direction.push('down')
  } else if (position.y > y) {
    let move = position.y - stride
    if (move < y) move = y
    nextPosition.y = move
    nextPosition.direction.push('up')
  }

  return nextPosition
}

export default {
  moveToTarget,
  moveDownLeft,
  moveUpLeft,
  moveLeft,
  moveDownRight,
  moveUpRight,
  moveRight,
  moveUp,
  moveDown,
  pause
}
